import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-lock-alt" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "py-m"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Přihlásit se ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Zapomenuté heslo")

import {
	NInput,
	NButton,
	NSpace,
	NAlert,
	NForm,
	NFormItem,
	NInputGroup,
	NInputGroupLabel,
	FormRules,
	FormValidationError,
} from 'naive-ui';
import { reactive, ref } from 'vue';
import { API } from '@/api';
import { useStore } from 'vuex';
import UnauthorizedLayout from '@/layouts/UnauthorizedLayout.vue';

interface Errors {
	username?: string;
	password?: string;
	message?: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { dispatch } = useStore();
const pending = ref<boolean>(false);
const formRef = ref();
const errors = reactive<Errors>({
	username: undefined,
	password: undefined,
	message: undefined,
});
const formModel = ref({
	username: undefined,
	password: undefined,
});
const rules = ref<FormRules>({
	username: [
		{
			required: true,
			message: 'E-mail je povinný',
			trigger: ['input', 'blur'],
		},
	],
	password: [
		{
			required: true,
			message: 'Heslo je povinné',
			trigger: ['input', 'blur'],
		},
	],
});
const submitForm = async () => {
	errors.username = undefined;
	errors.password = undefined;
	errors.message = undefined;

	if (formRef.value !== null && typeof formRef.value.validate === 'function') {
		await formRef.value.validate(async (validationErrors: FormValidationError) => {
			if (!validationErrors) {
				pending.value = true;
				try {
					const { payload } = await API.auth.login({
						username: (formModel.value.username || '').replace(/\s+/g, ''),
						password: formModel.value.password,
					});
					pending.value = false;

					if (!('token' in payload) || typeof payload.token !== 'string' || payload.token === '') {
						errors.message = 'Neplatné přihlášení';
					} else {
						await dispatch('auth/login', payload.token);
					}
				} catch (error) {
					pending.value = false;
					const catchError: AjaxResponseDto = error as AjaxResponseDto;
					const { message, fields } = catchError?.payload as MessageResponseDto;
					if (typeof fields === 'object' && fields !== null && Object.keys(fields).length > 0) {
						Object.keys(fields).forEach((key) => {
							if (key === 'username' || key === 'password') {
								errors[key] = fields[key];
							}
						});
					} else {
						errors.message = message || 'Neznámá chyba přihlášení';
					}
				}
			}
		});
	}
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UnauthorizedLayout, {
    width: "300px",
    title: "Přihlášení"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NForm), {
        ref_key: "formRef",
        ref: formRef,
        model: formModel.value,
        rules: rules.value,
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            path: "username",
            feedback: _unref(errors).username,
            "validation-status": _unref(errors).username ? 'error' : undefined,
            label: "E-mail"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.username) = $event)),
                    size: "large",
                    placeholder: "E-mail",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          _createVNode(_unref(NFormItem), {
            path: "password",
            feedback: _unref(errors).password,
            "validation-status": _unref(errors).password ? 'error' : undefined,
            label: "Heslo"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroupLabel), { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NInput), {
                    value: formModel.value.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.password) = $event)),
                    size: "large",
                    "show-password-on": "click",
                    type: "password",
                    placeholder: "Heslo",
                    disabled: pending.value
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["feedback", "validation-status"]),
          (_unref(errors).message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(NAlert), { type: "error" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(errors).message), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NSpace), {
            justify: "center",
            class: "py-m"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                "attr-type": "submit",
                style: { width: '100%' },
                disabled: 
						pending.value ||
						formModel.value.username === null ||
						formModel.value.username === '' ||
						formModel.value.password === null ||
						formModel.value.password === ''
					,
                loading: pending.value
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]),
      _createVNode(_unref(NSpace), {
        justify: "center",
        class: "pt-m"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/zapomenute-heslo",
            class: "text--s"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})